import React from 'react';
import SelectCustom from "../../../../common/components/input/SelectCustom"
import {
    FormControlLabel,
    Checkbox,
    Tooltip,
    Collapse
} from '@material-ui/core';

const disabledTooltipMessage = "To use this setting, go to Sheet Permissions";

const flexRow = {
    display: "flex",
    padding: "10px 10px 10px 0px",
    justifyContent: "space-between",
    alignItems: "center"
};

const canViewOptions = [
    { name: "All Rows", value: 1 },
    { name: "Rows Created By Them", value: 2 },
    { name: "Rows based on some criteria", value: 3, disabled: true, disabledTooltip: disabledTooltipMessage },
];
const canAddOptions = [
    { name: "Yes", value: 1 },
    { name: "No", value: 0 },
    { name: "Yes but allow add for some columns", value: 3, disabled: true, disabledTooltip: disabledTooltipMessage },
];
const canEditOptions = [
    ...canViewOptions,
    { name: "Nothing", value: 0 },
];

const canDeleteOptions = [
    ...canViewOptions,
    { name: "Nothing", value: 0 },
];

const dropDownStyle = {
    width: 200,
};

export default function Permissions({ data, onChange, isNewRole, modifiedSheets }) {
    const [isDisabled, setIsDisabled] = React.useState(modifiedSheets.length > 0);
    const disabledTooltipMessage = "Please click on above checkbox to continue editing";

    return (
        <div style={{
            padding: "10px 10px 10px 0px"
        }}>
            <span className="dialog_subtitle"> Edit Permissions </span>
            {
                !isNewRole && modifiedSheets.length > 0
                && <FormControlLabel
                    control={<Checkbox checked={!isDisabled} onChange={(ev) => setIsDisabled(!ev.target.checked)} />}
                    label={
                        <span style={{ color: "red" }}>
                            The permission for this role has been revised for the following sheets:
                            {modifiedSheets.map((modifiedSheet, key) =>
                            <b key={key}>
                                {modifiedSheet.name}
                                {(modifiedSheets.length - 1) !== key && ", "}
                            </b>)
                            }
                            <br />Override? <br />
                        </span>
                    }
                />
            }
            <Collapse in={!isDisabled || isNewRole} >
                <div style={flexRow}>
                    <b>Can View</b>
                    <TooltipForDisabled disabled={isDisabled && !isNewRole}>
                        <SelectCustom
                            name="can_view"
                            values={canViewOptions}
                            valueKey={"value"}
                            style={dropDownStyle}
                            value={data.can_view}
                            onChange={onChange}
                            disabled={isDisabled && !isNewRole}
                        />
                    </TooltipForDisabled>
                </div >
                <div style={flexRow}>
                    <b>Can Add</b>
                    <TooltipForDisabled disabled={isDisabled && !isNewRole} >
                        <SelectCustom
                            values={canAddOptions}
                            valueKey={"value"}
                            style={dropDownStyle}
                            name="can_add"
                            value={data.can_add}
                            onChange={onChange}
                            disabled={isDisabled && !isNewRole}
                        />
                    </TooltipForDisabled>
                </div>
                <div style={flexRow}>
                    <b>Can Edit</b>
                    <TooltipForDisabled disabled={isDisabled && !isNewRole} >
                        <SelectCustom
                            values={canEditOptions}
                            valueKey={"value"}
                            style={dropDownStyle}
                            name="can_edit"
                            value={data.can_edit}
                            onChange={onChange}
                            disabled={isDisabled && !isNewRole}
                        />
                    </TooltipForDisabled>
                </div>
                <div style={flexRow}>
                    <b>Can Delete</b>
                    <TooltipForDisabled disabled={isDisabled && !isNewRole} >
                        <SelectCustom
                            values={canDeleteOptions}
                            valueKey={"value"}
                            style={dropDownStyle}
                            name="can_delete"
                            value={data.can_delete}
                            onChange={onChange}
                            disabled={isDisabled && !isNewRole}
                        />
                    </TooltipForDisabled>
                </div>
            </Collapse>
        </div>
    );
}

const TooltipForDisabled = ({ children, disabled }) => {
    if (disabled) {
        return (
            <Tooltip title="Please click on above checkbox to continue editing" arrow >
                <div>{children}</div>
            </Tooltip>
        )
    }
    return children;
}

export function getPermissionDescription(data) {
    const canViewDescription = canViewOptions.find(option => option.value == data.can_view);
    const canEditDescription = canEditOptions.find(option => option.value == data.can_edit);
    const canDeleteDescription = canDeleteOptions.find(option => option.value == data.can_delete);
    const canAddDescription = canAddOptions.find(option => option.value == data.can_add);

    return (
        `Can View:  ${canViewDescription.name},  
        Can Add:  ${canAddDescription.name},  
        Can Edit: ${canEditDescription.name}, 
        Can Delete: ${canDeleteDescription.name}`
    );
}